import { createFileRoute } from '@tanstack/react-router'

import { LoginPage, routeOptions } from '@/modules/auth'

export const Route = createFileRoute('/login')({
  ...routeOptions,
  staticData: { title: 'Login' },
  component: LoginPage,
})
